// Career Mode — English (default language).
/* eslint-disable no-template-curly-in-string */
const resources = {
    tiers: { facil: 'Easy', medio: 'Medium', dificil: 'Hard', imposible: 'Impossible' },

    common: {
        continue: 'Continue',
        close: 'Close',
        cancel: 'Cancel',
        save: 'Save',
        confirm: 'Confirm',
        back: 'Back',
        yes: 'Yes',
        no: 'No',
        vs: 'vs',
        away: '@',
        free: 'Free',
        go: 'Go',
    },

    maintenance: {
        title: 'ELITE CAREER UNDER MAINTENANCE',
        line1: "We're improving the game with a bunch of new stuff.",
        line2: "You'll be able to play again soon! 🙌",
        thanks: 'Thanks for your patience 💛',
        adminBanner: '🔧 Elite Career is UNDER MAINTENANCE — only admins can play. (Change this from the admin panel.)',
    },

    noauth: {
        title: '⚽ ELITE CAREER',
        text: 'You need to log in to play Elite Career. That way we save your progress and achievements.',
        login: 'Log in',
        backHome: 'Back to home',
    },

    welcome: {
        emoji: '⚽💛',
        title: 'Welcome to Elite Career!',
        text1: "This game is a bit different from others: you don't pick a ready-made team, you start with a player you create yourself, from scratch.",
        text2: 'You’ll have to earn every call-up, every title, and every move to an elite club through your own decisions and results.',
        text3: 'We made this with a whole lot of love. If you enjoy it, it means the world if you share your career on social media or with friends. 💛',
        button: "Let's play!",
    },

    tour: {
        skip: 'Skip',
        next: 'Next',
        prev: 'Back',
        finish: 'Got it!',
        stepOf: 'Step {{current}} of {{total}}',
        steps: {
            tables: {
                title: '📊 Tables',
                text: 'Here you can see your league table and the cups you take part in. They update match by match.',
            },
            achievements: {
                title: '🏆 Achievements',
                text: 'Tap here to see every achievement you can earn in your career, and your progress on each one.',
            },
            stats: {
                title: '⚡ Attributes',
                text: "Manage your player's attributes here. As you earn points, you can distribute them however you like.",
            },
            seleccion: {
                title: '🌍 National Team',
                text: "If your level is high enough, you'll get called up to your country's national team. Follow qualifiers and the World Cup here.",
            },
            tactics: {
                title: '📋 Tactics',
                text: "Pick your team's tactic before each match to get the most out of your player.",
            },
            simulate: {
                title: '▶️ Simulate',
                text: 'Use these buttons to advance match by match. You can also turn on auto mode to simulate several matches in a row.',
            },
        },
    },

    loading: {
        text: 'Loading Elite Career...',
    },

    creator: {
        title: '⚽ ELITE CAREER',
        subtitle: 'Create your player and start your story from scratch.',
        tabDatos: '📋 Info',
        tabCabeza: '🧑 Head',
        tabCuerpo: '👕 Body',
        defaultPlayerName: 'Your player',
        nameLabel: 'Name',
        namePlaceholder: 'Your player name',
        nationalityLabel: 'Nationality',
        nationalityPlaceholder: 'Choose your nationality',
        positionLabel: 'Position',
        physicalLabel: 'Physique',
        heightLabel: 'Height',
        weightLabel: 'Weight',
        attributesLabel: 'Attributes · points to assign',
        skinLabel: 'Skin',
        hairLabel: 'Hairstyle',
        hairColorLabel: 'Hair color',
        beardLabel: 'Beard',
        glassesLabel: 'Glasses',
        glassesColorLabel: 'Glasses color',
        outfitLabel: 'Outfit',
        patternLabel: 'Pattern',
        primaryColorLabel: 'Primary color',
        secondaryColorLabel: 'Secondary color',
        secondaryColorHint: '(pattern / details)',
        shortsLabel: 'Shorts',
        socksLabel: 'Socks',
        bootsLabel: 'Boots',
        bootsStyleLabel: 'Boots style',
        accessoryLabel: 'Accessory',
        accessoryColorLabel: 'Accessory color',
        creating: 'Creating...',
        createButton: 'Create player',
        customColorTitle: 'Pick another color',
    },

    avatar: {
        peinado: {
            shortFlat: 'Short', shortWaved: 'Wavy', shortCurly: 'Short curls', shortRound: 'Buzz cut',
            theCaesar: 'Caesar', theCaesarAndSidePart: 'Caesar with side part', sides: 'Side part',
            shavedSides: 'Shaved sides', straight01: 'Straight', straight02: 'Straight 2',
            straightAndStrand: 'Straight with strand', longButNotTooLong: 'Medium length',
            frizzle: 'Frizzy', curly: 'Curly', curvy: 'Long wavy', shaggy: 'Shaggy',
            bob: 'Bob', fro: 'Afro', froBand: 'Afro + headband', dreads01: 'Dreadlocks',
            dreads02: 'Dreadlocks 2', dreads: 'Long dreadlocks', bun: 'Bun', bigHair: 'Big hair',
            shaggyMullet: 'Mullet', hat: 'Cap', turban: 'Turban', winterHat1: 'Beanie', pelado: 'Bald',
        },
        barba: {
            ninguna: 'No beard', beardLight: 'Light stubble', beardMedium: 'Medium beard',
            beardMajestic: 'Full beard', moustacheFancy: 'Moustache', moustacheMagnum: 'Big moustache',
        },
        lentes: {
            ninguno: 'None', round: 'Round', sunglasses: 'Sunglasses', wayfarers: 'Wayfarer',
            prescription01: 'Prescription', prescription02: 'Prescription 2', kurt: 'Kurt', eyepatch: 'Eyepatch',
        },
        atuendo: {
            remera: 'T-shirt', remera_v: 'V-neck T-shirt', manga_larga: 'Long sleeve', buzo: 'Hoodie',
            sueter: 'Sweater', campera: 'Jacket', traje: 'Suit', conjunto: 'Tracksuit',
        },
        patron: {
            liso: 'Plain', rayas_v: 'Vertical stripes', rayas_h: 'Horizontal stripes', banda: 'Sash',
        },
        botinEstilo: {
            clasico: 'Classic', altos: 'High-top', franja: 'With stripe',
        },
        accesorio: {
            ninguno: 'None', capitan: "Captain's armband", vincha: 'Headband', guantes: 'Gloves', munequeras: 'Wristbands',
        },
    },

    clubPicker: {
        title: 'CHOOSE YOUR FIRST CLUB',
        subtitle: '{{nombre}} · {{nacionalidad}} · {{posicion}} · Rating {{rating}}',
        hint: 'These are your 3 options to start your career. Choose one to continue.',
        choose: 'Choose',
        adminAnyClub: '🛠️ Admin: go to any club',
    },

    header: {
        achievementsTooltip: 'Achievements earned across all your careers',
        achievements: 'Achievements',
        calledUp: 'Called up to the national team',
        notCalledUp: "The coach doesn't consider you fit for a call-up yet",
        seasonLabel: 'Season {{n}}',
        ageYears: '{{n}} years old',
        marketValue: '💰 ${{n}}M',
        statsTooltip: 'Goals and assists this season',
        contractTooltip: 'Seasons remaining on contract',
        contractYears_one: '📝 {{n}} year',
        contractYears_other: '📝 {{n}} years',
        suspended: '🟥 Suspended {{n}}gw',
    },

    next: {
        selectionNowTag: 'NATIONAL TEAM · NOW',
        selectionNotCalledNote: "🚫 The coach didn't consider you fit for this call-up: your team plays without you.",
        laterTag: 'AFTER',
        nowTag: 'NOW',
        jornada: 'Matchday {{n}} · {{venue}}',
        home: 'Home',
        away: 'Away',
        idaResultPrefix: '🔁 1st leg: ',
        koAutoPauseNote: '⏸ Auto mode pauses for knockout matches.',
    },

    mobile: {
        results: '📋 Results',
        tables: '📊 Tables',
        selectionTab: '🌍 National team',
        cupTab: 'Cup',
        leagueTab: '🏆 League',
    },

    status: {
        moral: '😤 Morale',
        openTactics: '📋 Tactics board',
    },

    actions: {
        simulateFast: '⚡ Simulate matchday (Fast)',
        simulateSlow: '🐢 Simulate matchday (Slow)',
        playEuroFast: '⚡ Play {{copa}} (Fast)',
        playEuroSlow: '🐢 Play {{copa}} (Slow)',
        playSelectionFast: '⚡ Play national team (Fast)',
        playSelectionSlow: '🐢 Play national team (Slow)',
        playMundialFast: '⚡ Play World Cup (Fast)',
        playMundialSlow: '🐢 Play World Cup (Slow)',
        shortFast: '⚡ Fast',
        shortSlow: '🐢 Slow',
        shortEuro: '⚡ {{copa}}',
        shortEuroSlow: '🐢 {{copa}}',
        shortSelection: '⚡ National team',
        shortSelectionSlow: '🐢 National team',
        shortMundial: '⚡ World Cup',
        shortMundialSlow: '🐢 World Cup',
        autoStart: '⏩ Auto Simulate',
        autoStartShort: '⏩ Auto',
        autoStop: '⏸ Stop',
        attributes: '⚡ ATTRIBUTES',
        attributesShort: '⚡ Attr',
        seasonFinished: 'Season finished',
        simulating: 'Simulating...',
        fastTooltip: 'Simulates the matchday instantly, no animation',
        slowTooltip: "Simulates the matchday with a minute-by-minute animation of your match",
        autoTooltip: 'Auto-advances matchdays until the season ends or an offer arrives',
        retire: '🎙️ Retire',
    },

    results: {
        title: 'Latest results',
        suspended: '🟥 Suspended',
    },

    careerHistory: {
        title: '🏆 Career',
    },

    tables: {
        club: 'Club',
        country: 'Country',
        played: 'P',
        won: 'W',
        drawn: 'D',
        lost: 'L',
        goalsFor: 'GF',
        goalsAgainst: 'GA',
        goalDiff: 'GD',
        points: 'Pts',
        group: 'Gr',
        legendLibertadores: 'Copa Libertadores',
        legendSudamericana: 'Copa Sudamericana',
        legendChampions: 'Champions League',
        legendEuropa: 'Europa League',
        legendPromotion: 'Promotion',
        legendRelegation: 'Relegation',
        legendLast16Direct: 'Round of 16 (direct)',
        legendPlayoff16: 'Round of 16 playoff',
        legendEliminated: 'Eliminated',
        legendLast16DirectShort: 'Round of 16',
        legendPlayoffShort: 'Playoff',
        conmebolOctavos2: 'Round of 16 (1st & 2nd)',
        conmebolOctavos1: 'Round of 16 (1st)',
        conmebolDown: '3rd → Sudamericana',
        conmebol16: 'Round of 32 (2nd)',
        tbd: 'TBD',
        groupLetter: 'Group {{letter}}',
        tableTitle: 'Table — {{nombre}}',
    },

    competitions: {
        champions: 'Champions League',
        europa: 'Europa League',
        libertadores: 'Copa Libertadores',
        sudamericana: 'Copa Sudamericana',
        generic: 'Cup',
        groupStage: 'Group stage',
        leaguePhase: 'League phase',
        groupStageJ: 'Group stage · MD{{n}}',
        leaguePhaseJ: 'League phase · MD{{n}}',
        libertadoresGroupNote: '📋 Group stage. 1st & 2nd → Round of 16. 3rd drops to Sudamericana.',
        sudamericanaGroupNote: '📋 Group stage. 1st → Round of 16. 2nd plays Round of 32 vs a Libertadores 3rd.',
        leaguePhaseNote: '📋 League phase. Top 8 → Round of 16 direct, 9-24 → Round of 32 playoff.',
        teamAlive: 'your team is still in ✅',
        teamEliminated: 'your team was eliminated ❌',
        championYou: '🏆 Your team is the CHAMPION!',
        championOther: '🏆 Champion: {{nombre}}',
    },

    koRounds: {
        '16avos': 'Round of 32',
        octavos: 'Round of 16',
        cuartos: 'Quarter-finals',
        semis: 'Semi-final',
        final: 'Final',
    },

    months: {
        1: 'January', 2: 'February', 3: 'March', 4: 'April', 5: 'May', 6: 'June',
        7: 'July', 8: 'August', 9: 'September', 10: 'October', 11: 'November', 12: 'December',
    },

    clasif: {
        uefaTexto: '1st → World Cup · 2nd (and best 3rds) → Playoff · rest out',
        uefaDetalle: '12 groups. The group winner goes straight to the World Cup (12 spots). The 12 runners-up + the 4 best 3rd-placed teams play a playoff for the remaining 4 spots.',
        uefaPlayoffSub: '(the 12 group runners-up also go straight to the play-off)',
        asiaTexto: '1st & 2nd → World Cup · best 3rd → Playoff · rest out',
        asiaDetalle: '4 groups. The 1st and 2nd of each group go straight to the World Cup (8 spots). The 4 third-placed teams play a playoff for 1 spot.',
        africaTexto: '1st → World Cup · 4 best 2nds → Playoff · rest out',
        africaDetalle: '9 groups. The group winner goes straight to the World Cup (9 spots). The 4 BEST runners-up (among all 9 groups) play a single-match playoff; the winner takes the 10th and last African spot.',
        concacafTexto: '1st → World Cup · 2nd → Cross playoff · rest out',
        concacafDetalle: '4 groups. The group winner goes straight to the World Cup (4 spots). The 4 runners-up are crossed (G1-G3, G2-G4) over two legs for the remaining 2 spots.',
        conmebolTexto: '1st to 6th → World Cup · rest out',
        conmebolDetalle: 'Single league (round robin). The top 6 in the table go straight to the World Cup.',
        oceaniaTexto: '1st → World Cup · rest out',
        oceaniaDetalle: 'Single league (round robin). Only the table topper goes to the World Cup.',
        classifies: 'Qualifies',
        playoff: 'Playoff',
        bestSecondsTitle: 'Runners-up from each group',
        bestThirdsTitle: 'Third-placed teams from each group',
        goesToPlayoffN: 'Goes to playoff (best {{n}})',
        mundialQualifyLegend: '1st and 2nd → Round of 32 · best 3rds also',
    },

    mundial: {
        bestThirdsTitle: '🥉 Best third-placed teams (8 advance to Round of 32)',
        bestThirdsLegend: 'Advances to Round of 32 (8 best third-placed teams)',
        groupStage: '🌍 World Cup · Group stage',
        groupStageDate: '🌍 World Cup · Groups (matchday {{n}}/3)',
        finished: '🌍 World Cup · Finished',
        round: '🌍 World Cup · {{ronda}}',
        finalRound: '🌍 World Cup · Final',
        eliminatedSpectator: '🌍 World Cup · You\'re out — watch how it ends',
        notQualifiedSpectatorHint: "You didn't qualify — follow the World Cup. Advance to see how it goes.",
        championPrefix: '🏆 Champion: ',
        runnerUpLabel: ' · 🥈 {{nombre}}',
        groupLabel: 'Group {{letra}}',
        bracketTitle: 'World Cup bracket',
        yourPath: 'Your path',
        groupPhaseTitle: 'Group stage',
        pendingBracketNote: "The bracket will be built match by match.",
        outTitle: '🌍 National team · Eliminated',
        outOfWorldCup: 'Your national team is out of the World Cup.',
        outOfWorldCupSub: "You won't play with your national team until the next qualifiers (next cycle).",
        playoffTitle: '🌍 World Cup Playoff',
        playoffLeg: '{{ronda}} (1st leg)',
        playoffLegVuelta: '{{ronda}} (2nd leg)',
        playoffRoundIda: 'Playoff · 1st leg',
        playoffRoundVuelta: 'Playoff · 2nd leg',
        playoffRound: 'Playoff',
        playoffSummaryPre: 'Two-leg tie vs ',
        playoffSummaryPost: ' for the last spot. Aggregate {{favor}}-{{contra}}.',
        playoffNote: 'Win on aggregate → World Cup. Lose → out.',
        prePlayoffTitle: '🌍 CONCACAF Pre-playoff',
        prePlayoffSummary: "You're from pot 4: win 2 rounds to enter the group stage.",
        qualifiedTitle: '🌍 ✅ Qualified for the World Cup',
        qualifiedNote: 'Your national team will play the next World Cup!',
        qualifyingTitle: '🌍 Qualifiers · Year {{n}}/4',
    },

    modals: {
        attributes: {
            title: '⚡ Attributes · {{posicion}}',
            ratingLabel: 'Rating',
            pointsLabel: 'Points to assign:',
            resetButton: '♻️ Reset all (costs 1 point)',
            removeAria: 'Remove',
            addAria: 'Add',
        },
        achievements: {
            title: '🏆 Achievements',
            subtitle: 'Saved across all your careers, with the date and club you earned them with. Progress on single-career achievements resets when you start a new one.',
            close: 'Close',
        },
        callup: {
            title: 'Congratulations!',
            textPre: "You've been called up to the ",
            textMid: ' with the national team of ',
            textPost: '.',
            worldCupWord: 'World Cup',
            text2: "Every footballer's dream! Leave it all on the pitch. 🏆",
            button: "Let's go!",
        },
        seleccion: {
            calledUp: '⭐ Called up to the national team',
            notCalledUp: "🚫 The coach doesn't consider you fit for a call-up yet.",
            phaseClasif: '🟡 Qualifiers in progress',
            phaseClasificado: '✅ Qualified for the World Cup',
            phasePlayoff: '⚠️ Playoff',
            phaseEliminado: '❌ Eliminated',
            cycleLine: ' · Cycle {{ciclo}} / Year {{año}}/4',
            outOfWorldCup: 'Your national team is out of the World Cup.',
            outOfWorldCupSub: "You won't play with your national team until the next qualifiers (next cycle).",
            groupTableTitle: 'Group table',
            upcomingTitle: 'Upcoming matches',
            upcomingLine: 'Year {{año}} · {{venue}} {{rival}} ({{estrellas}})',
            cycleStats: '📊 This cycle: <b>{{pj}}</b> P · <b>{{g}}</b> G · <b>{{a}}</b> A',
            careerStats: '🌍 Career: <b>{{pj}}</b> P · <b>{{g}}</b> G · <b>{{a}}</b> A · <b>{{w}}</b> World Cups',
        },
        season: {
            title: 'Season {{n}} finished',
            finishedLine: 'You finished {{pos}}{{ord}} in {{liga}}.',
            yourLeague: 'your league',
            played: 'Played',
            goals: 'Goals',
            assists: 'Assists',
            minutes: 'Minutes',
            ratingLine: 'Rating: {{prev}} → {{next}}',
            marketValueLine: 'Market value: ${{n}}M',
            promoted: '🔼 You got promoted to the top division!',
            relegated: '🔽 You got relegated to the second division.',
        },
        liveMatch: {
            fallbackHeader: 'Matchday {{n}} · {{venue}}',
            qualifiersHeader: '🌍 World Cup Qualifiers · Year {{n}}/3{{nc}}',
            notCalledShort: ' · 🚫 Not called up',
            prePlayoffHeader: '🌍 CONCACAF Pre-playoff · {{ronda}}',
            playoffHeader: '🌍 World Cup Playoff · {{ronda}}{{leg}}',
            legIda: ' · 1st leg',
            legVuelta: ' · 2nd leg',
            mundialGroupHeader: '🌍 World Cup · Group stage · Matchday {{n}}',
            mundialKOHeader: '🌍 World Cup · {{ronda}}',
            secondLegLine: '🔁 2nd leg · 1st leg: <bold>{{score}}</bold> (aggregate decided here)',
            penaltiesTitle: '🥅 Penalty shootout',
            suddenDeath: 'Sudden death',
            advancedPens: '✅ You advanced {{favor}}-{{contra}} on penalties!',
            eliminatedPens: '❌ Eliminated {{contra}}-{{favor}} on penalties',
            kickingOn: 'Kicking…',
            ownGoal: '⚽ Your goal',
            ownAssist: '🅰️ Your assist',
            opponentGoal: '⚽ {{equipo}}',
            goalFlashOwn: "⚽ YOUR GOAL! ({{min}}')",
            goalFlashOwnAssist: "🅰️ Your assist! ({{min}}')",
            goalFlashOther: "⚽ Goal for {{equipo}} ({{min}}')",
        },
        evento: {
            title: 'Event',
        },
        tacticas: {
            title: '📋 Tactics board',
            done: 'Done',
        },
        transfer: {
            titleDefault: 'Transfer offers',
            textDefault_one: 'You have {{n}} transfer offer. What do you want to do?',
            textDefault_other: 'You have {{n}} transfer offers. What do you want to do?',
            titleExpiredRenewal: 'Your contract expired',
            textExpiredRenewal: 'Your club wants to renew you, but other teams want you too. Choose to renew or sign with another club.',
            titleExpiredNoRenewal: "Your club won't renew you",
            textExpiredNoRenewal: "Your club decided not to renew your contract. You must choose one of the following clubs.",
            renewalTag: ' · Renewal',
            minutesWarn: '⚠️ You\'ll barely play (~{{n}}\'/match)',
            minutesLimited: "🟡 Limited minutes (~{{n}}'/match)",
            minutesStarter: "✅ Starter (~{{n}}'/match)",
            renewalContract_one: '📝 {{n}}-year contract',
            renewalContract_other: '📝 {{n}}-year contract',
            offerContract_one: '{{monto}}M · 📝 {{n}} year',
            offerContract_other: '{{monto}}M · 📝 {{n}} years',
            finishedFinal: 'finished',
            goingPos: 'currently',
            renew: 'Renew',
            sign: 'Sign',
            stay: 'Stay at my club',
            adminAnyClub: '🛠️ Admin: go to any club',
        },
        adminClubPicker: {
            title: '🛠️ Admin: go to any club',
            hint: 'Testing only. Instantly signs you to the chosen club, no offers involved.',
            searchPlaceholder: 'Search club, league or country...',
            go: 'Go',
            close: 'Close',
        },
        retire: {
            forcedBanner: 'At {{n}} years old you say goodbye to professional football. What a career!',
            cardTitle: '⚽ FOOTY · ELITE CAREER',
            statsTitle: 'Statistics',
            statPartidos: 'MATCHES',
            statGoles: 'GOALS',
            statAsistencias: 'ASSISTS',
            statTitulos: 'TITLES',
            trophiesTitle: 'Trophies',
            league_one: 'League',
            league_other: 'Leagues',
            nationalTeamTitle: 'National team',
            bestLine: 'Best: World Cup cycle {{ciclo}} (age {{edad}}) — {{result}}',
            bestLineWith: ' with {{pais}}',
            worldCupHash: 'World Cup #{{ciclo}} · age {{edad}}',
            careerTitle: 'Career path',
            footer: 'Play your career at www.footy-games.com.ar',
            share: '📸 Share',
            download: '📥 Download',
            generating: 'Generating…',
            backButton: 'Back',
            newCareer: 'Start new career',
            confirmRetire: 'Confirm retirement',
        },
        nationality: {
            title: 'Choose your nationality',
            close: 'Close',
        },
    },

    toast: {
        offerPending: 'You need to decide the transfer offer before continuing.',
        matchdayError: 'Error advancing the matchday.',
        loadCareerError: 'Error loading your save.',
        loadClubOptionsError: 'Error fetching club options.',
        gameError: 'Error creating the save.',
        chooseClubError: 'Error choosing the club.',
        adminChangeClubError: 'Error switching club (admin).',
        adminNowAt: '(Admin) You now play for {{nombre}}.',
        signedWith: 'Signed with {{nombre}}!',
        couldNotSave: "Couldn't save your progress. Check your connection and try again.",
        offerProcessError: 'Error processing the offer. Try again.',
        nameRequired: 'Enter a name for your player.',
        nationalityRequired: 'Choose your nationality.',
        attributesUpdated: 'Attributes updated.',
        seasonFinished: 'Season finished!',
        seasonFinishedShort: 'Season finished.',
        dayOff: 'Your team had the day off this matchday.',
        koPauseNote: '⏸ This is a knockout match: play it yourself (Fast or Slow).',
        selectionTurnNote: "🌍 It's your turn with the national team! Play the match yourself (Fast or Slow).",
        mundialTurnNote: '🌍 You\'re in the World Cup. Play the matches yourself (Fast or Slow).',
        worldCupGroupsDone: '🌍 World Cup: group stage is over. The Round of 32 begins.',
        worldCupGroupDate: '🌍 World Cup: matchday {{n}}/3 of the groups was played.',
        worldCupFinished: '🌍 World Cup over! Champion: {{campeon}}.',
        worldCupRoundPlayed: '🌍 World Cup: {{ronda}} were played.',
        worldCupRoundPlayedWatch: '🌍 World Cup: {{ronda}} were played. See how the bracket continues.',
        worldCupKOAdvance: "🌍 You're through! {{ronda}}: your opponent is {{rival}}.",
        worldCupStartedNotCalled: "🌍 The World Cup begins. The coach didn't consider you fit for this call-up: your national team plays without you. You can follow it in the panel.",
        suspendedLeague: '🟥 Suspended (red card): you miss this league matchday.',
        wonLost: { won: 'Won', lost: 'Lost', drawn: 'Drawn' },
        notCalledScore: '🌍 {{ronda}}: 🚫 Not called up — your national team played without you {{score}} {{venue}} {{rival}}',
        prePlayoffToGroups: '   ✅ Into the group stage!',
        prePlayoffEliminated: '   ❌ Eliminated in the pre-playoff',
        playoffQualified: '   ✅ Qualified for the World Cup!',
        playoffEliminated: '   ❌ You\'re out of the World Cup',
        worldChampion: '   🏆 WORLD CHAMPION!',
        nextRound: '   ✅ Through to the next round',
        eliminatedWC: '   ❌ Eliminated from the World Cup',
        suspendedCup: '🟥 Suspended — your team played without you {{score}} {{venue}} {{rival}}',
        aggregateScore: '   Aggregate {{favor}}-{{contra}}{{pens}}',
        aggregatePens: ' · Penalties {{favor}}-{{contra}}',
        champion: '   🏆 CHAMPION!',
        qualifiedNextRound: '   ✅ Qualified for the next round',
        eliminatedCup: '   ❌ Eliminated from the competition',
        imageDownloadedCopied: 'Image downloaded and text copied. Paste it in your post 📸',
        imageDownloaded: 'Your career image was downloaded 📸',
        imageDownloaded2: 'Your career image was downloaded 📥',
        imageError: "Couldn't generate the image.",
        retireError: 'Error retiring.',
        achievementUnlocked: '🏆 Achievement unlocked! {{titulo}}',
        eliminatorias: 'Qualifiers · Year {{n}}/3',
        prePlayoff: 'CONCACAF Pre-playoff',
        playoffIda: 'Playoff (1st leg)',
        playoffVuelta: 'Playoff (2nd leg)',
        playoffPlain: 'Playoff',
        worldCupGroupMatchday: 'World Cup · Matchday {{n}}',
        worldCupKO: 'World Cup · {{ronda}}',
        selectionGeneric: 'National team',
    },

    share: {
        text: "Hung up my boots 🎙️\n\nMy career as {{nombre}} ({{posicion}}):\n⚽ {{goles}} goals · 🅰️ {{asistencias}} assists in {{partidos}} matches\n{{palmares}}\n📈 Best rating {{rating}}\n\nPlay your career at www.footy-games.com.ar!",
        league_one: 'league',
        league_other: 'leagues',
        statsTitle: 'Statistics',
        statPartidos: 'MATCHES',
        statGoles: 'GOALS',
        statAsistencias: 'ASSISTS',
        statTitulos: 'TITLES',
        bestRatingLabel: 'BEST RATING',
        trophiesTitle: 'Trophies',
        nationalTeamTitle: 'National team',
        careerTitle: 'Career path',
        footer: 'Play your career at www.footy-games.com.ar',
        season_one: 'season',
        season_other: 'seasons',
        year_one: 'year',
        year_other: 'years',
        mundial_one: 'World Cup',
        mundial_other: 'World Cups',
        bestLine: 'Best: World Cup cycle {{ciclo}} (age {{edad}})',
        header: '⚽  FOOTY · ELITE CAREER',
        shareTitle: 'My Footy career',
        selChipGoals: 'Goals',
        selChipAssists: 'Assists',
        selChipMatches: 'MP',
        mundialRow: 'World Cup #{{ciclo}} · age {{edad}}',
        clubStatsRow: '{{pj}} MP · {{g}} G · {{a}} A',
        selStatsRow: '{{pj}} MP · {{g}}G',
    },

    tactica: {
        axis: { formacion: 'Formation', actitud: 'Attitude', presion: 'Pressing', estilo: 'Attacking style', marca: 'Marking' },
        values: {
            defensiva: 'Defensive', equilibrada: 'Balanced', ofensiva: 'Attacking', todo_o_nada: 'All-out attack',
            repliegue: 'Low block', media: 'Medium block', alta: 'High press',
            posesion: 'Possession', directo: 'Direct play', bandas: 'Down the wings', contra: 'Counter-attack',
            zona: 'Zonal marking', hombre: 'Man marking',
        },
    },

    attributes: {
        velocidad: 'Pace', tiro: 'Shooting', fisico: 'Physical', pase: 'Passing',
        defensa: 'Defending', fiesta: 'Partying & Drinking',
    },

    positions: {
        'Defensor Lateral': 'Fullback',
        'Defensor Central': 'Centre-back',
        'Mediocampista Defensivo': 'Defensive midfielder',
        'Mediocampista Ofensivo': 'Attacking midfielder',
        'Delantero Extremo': 'Winger',
        'Delantero Centro': 'Centre-forward',
    },

    mundialResult: { campeon: '🏆 Champion', final: '🥈 Final', semis: 'Semi-final', cuartos: 'Quarter-finals', octavos: 'Round of 16', '16avos': 'Round of 32', grupos: 'Group stage', no_clasif: 'Did not qualify' },

    scouting: {
        defensiva: "🕵️ They'll sit deep.",
        equilibrada: "🕵️ They'll play it even, no risks.",
        ofensiva: "🕵️ They'll come out to get you.",
        todo_o_nada: '🕵️ They\'ll go all-out attacking.',
        repliegue: '🕵️ They wait in a low block.',
        media: '🕵️ They press in their own half.',
        alta: '🕵️ They come to press you high.',
        posesion: '🕵️ They like to keep the ball.',
        directo: '🕵️ They play direct, into space.',
        bandas: '🕵️ They attack a lot down the wings.',
        contra: '🕵️ They wait to break on the counter.',
    },

    tacticaFeedback: {
        messyWin: '🤔 Your setup was a bit messy, but you got the win.',
        messyLose: '🤯 Your setup was contradictory and it showed on the pitch.',
        sharpWin: '🧠 You read the opponent perfectly: your setup tore them apart.',
        sharpLose: '🧠 Smart setup, you just lacked a finishing touch.',
        outreadWin: '😮‍💨 The opponent outsmarted you tactically, but you got away with it.',
        outreadLose: '❌ They read your setup and ran you over.',
        neatWin: '✅ Clean setup and a win.',
        neatDraw: '➖ Even setup, points shared.',
        neatLose: "🔻 Correct setup, it just didn't go your way.",
    },

    achievements: {
        facil_5_ligas: { title: 'Local Pentachamp', desc: 'Win 5 domestic leagues in a single career.' },
        facil_champions: { title: 'King of Europe', desc: 'Win a Champions League.' },
        facil_europa: { title: 'Continental Conquest', desc: 'Win a Europa League.' },
        facil_sudamericana: { title: 'South American Glory', desc: 'Win a Copa Sudamericana.' },
        facil_libertadores: { title: 'Eternal Glory', desc: 'Win a Copa Libertadores.' },
        facil_5_grandes: { title: 'Elite Globetrotter', desc: 'Play in the 5 big top-flight leagues (Spain, France, England, Italy, Germany) in a single career.' },
        facil_media_85: { title: 'Star Player', desc: 'Reach an 85 rating in a season.' },
        sel_facil_convocado: { title: 'Called Up', desc: 'Be called up to your national team at least once.' },
        sel_facil_5_goles: { title: 'National Goalscorer', desc: 'Score 25 goals with your national team in a single career.' },
        sel_facil_clasificar: { title: 'To the World Cup', desc: 'Qualify for a World Cup with your national team.' },
        medio_5_ligas_5_equipos: { title: 'Nomad Champion', desc: 'Win 5 domestic leagues with 5 different clubs in a single career.' },
        medio_3_intl_3_equipos: { title: 'Champion Globetrotter', desc: 'Win 3 international trophies with 3 different clubs in a single career.' },
        medio_5_ligas_mismo: { title: 'Eternal Idol', desc: 'Win 5 domestic leagues with the same club.' },
        medio_remontada_0_3: { title: 'Epic Comeback', desc: 'Turn a match around after being down 3-0.' },
        medio_3_clubs_5est: { title: 'Only for Elites', desc: 'Play for 3 clubs rated 5 stars in a single career.' },
        medio_45_atrib: { title: 'Elite Physique', desc: 'Apply 45 attribute points in a single career.' },
        medio_750_goles: { title: 'Goal Machine', desc: 'Score more than 750 goals in a single career.' },
        medio_media_90: { title: 'Crack', desc: 'Reach a 90 rating in a season.' },
        medio_liber_liga: { title: 'South American Double', desc: 'Win the Libertadores and the domestic league in the same season.' },
        medio_champ_liga: { title: 'European Double', desc: 'Win the Champions League and the domestic league in the same season.' },
        sel_medio_semifinal: { title: 'Final Four', desc: 'Reach the World Cup semi-final with your national team.' },
        sel_medio_gol_ko: { title: 'Knockout Goal', desc: 'Score a World Cup goal in a knockout match (round of 32 onward).' },
        sel_medio_clasif_15est: { title: 'Cinderella Qualifier', desc: 'Qualify for a World Cup with a 1.5-star (or lower) national team.' },
        sel_medio_final_35est: { title: 'World Cup Surprise', desc: 'Reach the World Cup final with a 3.5-star (or lower) national team.' },
        sel_medio_25_goles: { title: 'National Team Sharpshooter', desc: 'Score more than 50 goals with your national team in a single career.' },
        dificil_900_goles: { title: 'Legendary Goalscorer', desc: 'Score more than 900 goals in a single career.' },
        dificil_750_asist: { title: 'Playmaker', desc: 'Register more than 750 assists in a single career.' },
        imposible_900_asist: { title: 'Assist Wizard', desc: 'Register more than 900 assists in a single career.' },
        dificil_sudam_2est: { title: 'Sudamericana Cinderella', desc: 'Win a Sudamericana with a 2-star (or lower) club.' },
        dificil_europa_25est: { title: 'European Surprise', desc: 'Win a Europa League with a 2.5-star (or lower) club.' },
        dificil_intl_invicto: { title: 'Perfect Run', desc: 'Win an international tournament unbeaten.' },
        dificil_liber_cada_pais: { title: 'Master of the Libertadores', desc: 'Win the Libertadores with every South American country (not necessarily in the same career).' },
        dificil_sudam_cada_pais: { title: 'Master of the Sudamericana', desc: 'Win the Sudamericana with every South American country (not necessarily in the same career).' },
        dificil_champ_cada_pais: { title: 'Master of the Champions League', desc: 'Win the Champions League with every European country (not necessarily in the same career).' },
        dificil_europa_cada_pais: { title: 'Master of the Europa League', desc: 'Win the Europa League with every European country (not necessarily in the same career).' },
        dificil_media_95: { title: 'Super Crack', desc: 'Reach a 95 rating in a season.' },
        dificil_50_atrib: { title: 'Maximum Potential', desc: 'Apply 50 attribute points in a single career.' },
        dificil_un_club: { title: 'Eternal and Unbreakable', desc: 'Play your whole career at the same club and retire due to age (voluntary retirement doesn\'t count).' },
        sel_dificil_campeon: { title: 'World Champion', desc: 'Become World Cup champion with your national team.' },
        sel_dificil_gol_final: { title: 'Final Goal', desc: 'Score a goal in the World Cup final with your national team.' },
        sel_dificil_5_mundiales: { title: 'Five World Cups', desc: 'Play 5 different World Cups.' },
        sel_dificil_8_goles_mun: { title: 'Golden Boot', desc: 'Score more than 8 goals in a single World Cup.' },
        sel_dificil_50_goles: { title: 'National Team Legend', desc: 'Score more than 75 goals with your national team in a single career.' },
        imposible_un_club_3est: { title: 'One-Club Legend', desc: 'Play your whole career at the same club rated at least 3 stars and retire due to age (voluntary retirement doesn\'t count).' },
        imposible_libertadores_2est: { title: 'Libertadores Miracle', desc: 'Win the Libertadores with a 2-star (or lower) club.' },
        imposible_champions_25est: { title: 'Immortal Feat', desc: 'Win the Champions League with a 2.5-star (or lower) club.' },
        imposible_liga_invicto_18: { title: 'The Invincibles', desc: 'Win a domestic top-flight league of 18+ teams unbeaten.' },
        imposible_media_99: { title: 'Greatest of All Time', desc: 'Reach a 99 rating in a season.' },
        sel_imp_campeon_2est: { title: 'World Cup Feat', desc: 'Win the World Cup with a 2-star (or lower) national team.' },
        sel_imp_12_goles_mun: { title: 'Just \'Like\' Fontaine', desc: 'Score at least 13 goals in a single World Cup.' },
        sel_imp_3_mundiales_gan: { title: 'O\'Rei Pelé', desc: 'Win 3 World Cups in a single career.' },
        sel_imp_75_goles: { title: 'Historic Goalscorer', desc: 'Score more than 100 goals with your national team in a single career.' },
    },
    eventos: {
            "fiesta_previa": {
                texto: "You get invited to a party the night before an important match.",
                opt0: { label: "🍻 I go all in", out0: "You crushed it and woke up fresh the next day. (+morale)", out1: "You showed up wrecked, the coach chewed you out. (−morale)" },
                opt1: { label: "🍷 I go for a bit and leave early", out0: "You said hi to everyone and rested. Balanced. (+morale)", out1: "You left right when it got good. Meh." },
                opt2: { label: "🛌 I stay home and rest", out0: "Total professional. (+morale)", out1: "You still couldn't sleep thinking about what you missed. (−morale)" },
            },
            "entreno_extra": {
                texto: "The fitness coach offers you extra training.",
                opt0: { label: "💪 I push myself hard", out0: "The work paid off: +1 attribute point.", out1: "You overdid it and got a nagging injury. (−morale)" },
                opt1: { label: "🏃 I do just a little", out0: "You added value without risk. (+morale)", out1: "Light jog and home. Normal." },
                opt2: { label: "🚗 I go home", out0: "You rested. Nothing new.", out1: "The coach took it as a lack of commitment. (−morale)" },
            },
            "sponsor": {
                texto: "A brand offers you to be the face of their campaign.",
                opt0: { label: "✍️ I sign the big contract", out0: "Your face everywhere, it boosted your mood. (+morale)", out1: "The campaign flopped and you got mocked. (−morale)" },
                opt1: { label: "🤝 I negotiate better terms", out0: "You got more money with patience. (+morale)", out1: "You overreached and it all fell through. (−morale)" },
                opt2: { label: "🙅 I pass", out0: "Low profile, focus on football. (+morale)", out1: "Your teammates called you foolish over the money. (−morale)" },
            },
            "prensa": {
                texto: "A journalist trashes you, saying you're overrated.",
                opt0: { label: "🔥 I fire back hard", out0: "You called him out with class, the fans backed you. (+morale)", out1: "You got too heated and it looked bad. (−morale)" },
                opt1: { label: "😏 I throw a sharp jab", out0: "You left him speechless. Genius. (+morale)", out1: "Nobody got your irony. It passed." },
                opt2: { label: "😶 I ignore him", out0: "You talk with your feet. (+morale)", out1: "Your silence was read as him being right. (−morale)" },
            },
            "vestuario": {
                texto: "There's tension in the locker room between two senior players.",
                opt0: { label: "🕊️ I step in and calm things down", out0: "You cooled things off, they see you as a leader. (+morale)", out1: "You got involved where you shouldn't have. (−morale)" },
                opt1: { label: "🤐 I stay neutral", out0: "You didn't take sides. Sensible.", out1: "It blew over without your involvement." },
                opt2: { label: "🍿 I throw fuel on the fire", out0: "The mess escalated and it showed on the pitch. (−morale)", out1: "You enjoyed the drama. (+slight morale)" },
            },
            "molestia": {
                texto: "You're carrying a knock and the medical staff let you choose.",
                opt0: { label: "🏃 I push through and play", out0: "You gritted it out and delivered. Unstoppable. (+morale)", out1: "It got much worse. (−morale)" },
                opt1: { label: "💊 I get an injection and see", out0: "It held up just enough for the match. (+slight morale)", out1: "The injection left you worse off. (−morale)" },
                opt2: { label: "🧊 I rest and take care of myself", out0: "You come back at full strength. (+morale)", out1: "It was nothing, you missed the match for nothing. (−morale)" },
            },
            "hincha": {
                texto: "A kid waits 3 hours at the club's gate to meet you.",
                opt0: { label: "🤗 I sign autographs and take photos", out0: "The video went viral, you're the most beloved. (+morale)", out1: "You made his day. Beautiful. (+morale)" },
                opt1: { label: "✋ I wave as I pass by", out0: "Small but kind gesture. (+slight morale)", out1: "You barely saw him. It passed." },
                opt2: { label: "🏃 I'm in a rush, another day", out0: "You left him hanging and it went on social media. (−morale)", out1: "You had a doctor's appointment, they understood." },
            },
            "casino": {
                texto: "Some teammates invite you to the casino after the match.",
                opt0: { label: "🎲 I bet big", out0: "You piled up the chips. (+morale)", out1: "You lost money and sleep. (−morale)" },
                opt1: { label: "🍹 I just tag along", out0: "You unwound without spending. (+slight morale)", out1: "A soda and home. Chill." },
                opt2: { label: "🏠 I head home", out0: "Clear head. (+slight morale)", out1: "You missed an epic night. (−morale)" },
            },
            "asado": {
                texto: "It's team barbecue day and you're on grill duty.",
                opt0: { label: "🔥 I take charge of the grill", out0: "Godlike barbecue, you won over the locker room. (+morale)", out1: "You burned the meat and got roasted for it. (−morale)" },
                opt1: { label: "🥗 I handle the salads", out0: "You delivered without risk. (+slight morale)", out1: "Nobody ate the salad. Meh." },
                opt2: { label: "🥤 I just bring the drinks", out0: "Simple mission accomplished.", out1: "You brought warm soda. Embarrassing. (−morale)" },
            },
            "tatuaje": {
                texto: "You want to get a tattoo before the tournament.",
                opt0: { label: "🖊️ A giant club crest on your arm", out0: "The fans flipped out, idol status. (+morale)", out1: "It came out horrible and you want it removed. (−morale)" },
                opt1: { label: "🤏 Something small and discreet", out0: "Subtle and cool. (+slight morale)", out1: "Nobody noticed." },
                opt2: { label: "🚫 Better not get anything", out0: "Zero regrets.", out1: "You were left wanting. (−slight morale)" },
            },
            "representante": {
                texto: "Your agent tells you he can get you a move to a bigger club \"right now\".",
                opt0: { label: "🌍 I trust him right away", out0: "He got you excited about a great team. (+morale)", out1: "It was all smoke. (−morale)" },
                opt1: { label: "📑 I ask him to show me everything in writing", out0: "Professional, you covered yourself. (+morale)", out1: "He had nothing concrete. It passed." },
                opt2: { label: "🧐 I tell him to calm down", out0: "Feet on the ground. (+slight morale)", out1: "It turned out to be a real offer and you lost it. (−morale)" },
            },
            "mediatico": {
                texto: "You start dating a media personality and TV goes wild.",
                opt0: { label: "📺 I enjoy the fame", out0: "You handle it well and have fun. (+morale)", out1: "The circus badly distracted you. (−morale)" },
                opt1: { label: "🤫 I keep it private", out0: "Low profile, head in the game. (+morale)", out1: "It leaked anyway and you looked like a liar. (−morale)" },
                opt2: { label: "🚪 I end it, it distracts me", out0: "Total focus. (+slight morale)", out1: "You kept thinking about what you gave up. (−morale)" },
            },
            "var": {
                texto: "This weekend VAR disallowed a wonder goal and social media is still buzzing in your favor.",
                opt0: { label: "😡 I go off on VAR", out0: "The fans backed you to the death. (+morale)", out1: "You got hit with a suspension. (−morale)" },
                opt1: { label: "🤷 I throw out an ironic comment", out0: "It came off cool and funny. (+morale)", out1: "Nobody paid attention." },
                opt2: { label: "🙏 I let it go", out0: "Calm, payback is coming. (+morale)", out1: "Inside you stayed angry all week. (−morale)" },
            },
            "auto": {
                texto: "With your first big paycheck you want to buy an expensive car.",
                opt0: { label: "🤑 I buy the most expensive one", out0: "Total swagger. (+morale)", out1: "You crashed it within a week. Embarrassing. (−morale)" },
                opt1: { label: "🚙 Something nice but sensible", out0: "Good taste and prudence. (+slight morale)", out1: "A regular car. It does the job." },
                opt2: { label: "🏦 I'd rather save", out0: "Your mom is proud. (+morale)", out1: "You were left wanting. Meh." },
            },
            "tarde": {
                texto: "You overslept and you're late for training.",
                opt0: { label: "🏃 I make up an excuse", out0: "You got away with \"I had a flat tire\".", out1: "The coach didn't buy it and fined you. (−morale)" },
                opt1: { label: "🤐 I sneak in quietly", out0: "Nobody saw you come in. Lucky.", out1: "They caught you anyway. (−morale)" },
                opt2: { label: "📞 I call ahead and accept the fine", out0: "Honesty appreciated. (+morale)", out1: "You still got tagged as unpunctual. (−morale)" },
            },
            "foto_filtrada": {
                texto: "A photo of you partying at 4 AM in a club leaked.",
                opt0: { label: "😎 I own it, \"I was off duty\"", out0: "You laughed it off, it became a joke. (+morale)", out1: "Management called you out badly. (−morale)" },
                opt1: { label: "🙈 I issue a public apology", out0: "You put out the fire. Lesson learned. (+morale)", out1: "Turns out the photo was AI, it wasn't even you. You burned yourself for nothing. (−morale)", out2: "Nobody paid attention to your apology." },
                opt2: { label: "🤐 I say nothing", out0: "It was forgotten in two days.", out1: "The silence was read as guilt. (−morale)" },
            },
            "tv_baile": {
                texto: "You get invited onto a dance show mid-season.",
                opt0: { label: "🕺 I accept, I'm a star", out0: "You killed it dancing, won new fans. (+morale)", out1: "It was embarrassing and you showed up tired to training. (−morale)" },
                opt1: { label: "📅 I accept but only during the break", out0: "You handled it without neglecting football. (+morale)", out1: "It got postponed. Meh." },
                opt2: { label: "🙅 No, I'm focused", out0: "Work first. (+morale)", out1: "The one who went became famous. (−morale)" },
            },
            "comedor": {
                texto: "A local community kitchen asks for your help with the kids.",
                opt0: { label: "🤝 I donate and go say hi", out0: "You made their day, priceless. (+morale)", out1: "Nice gesture, though you got caught in the rain. (+morale)" },
                opt1: { label: "💸 I send money but don't go", out0: "You helped anyway. (+morale)", out1: "They said you're cold for not showing up. (−morale)" },
                opt2: { label: "🤷 I put it off for later", out0: "It stayed pending. It passed.", out1: "It became public that you didn't even reply. (−morale)" },
            },
            "provocacion": {
                texto: "In the last match a rival taunted you the whole game. You run into him at an event.",
                opt0: { label: "👊 I confront him", out0: "You cleared the air man to man. (+morale)", out1: "It almost came to blows and it was all over the news. (−morale)" },
                opt1: { label: "🤝 I offer my hand", out0: "Sporting gesture, you came off well. (+morale)", out1: "He left you hanging. You still looked good." },
                opt2: { label: "🧊 I ignore him", out0: "Whoever gets angry loses. (+morale)", out1: "You kept the anger bottled up. (−morale)" },
            },
            "cumple": {
                texto: "It's a teammate's birthday and there's a big pre-party on Thursday.",
                opt0: { label: "🍾 I go all in", out0: "You celebrated in moderation, strengthened the group. (+morale)", out1: "You overdid it and played like a rookie that weekend. (−morale)" },
                opt1: { label: "🥂 I say hi and leave early", out0: "Perfect balance. (+morale)", out1: "You missed the best part. Meh." },
                opt2: { label: "🎁 I send a gift and don't go", out0: "Thoughtful. You did your part.", out1: "He got offended you didn't show. (−morale)" },
            },
            "mate_dt": {
                texto: "The coach invites you for a cup of tea to talk about your role.",
                opt0: { label: "🧉 I sit down and listen", out0: "He gave you confidence and backed you. (+morale)", out1: "He told you you're on the bubble. Bummer. (−morale)" },
                opt1: { label: "🗣️ I speak my mind", out0: "He respected your honesty. (+morale)", out1: "He didn't like what you said at all. (−morale)" },
                opt2: { label: "🙄 I go out of obligation", out0: "He noticed you were half-hearted. (−morale)", out1: "You talked about nothing in particular." },
            },
            "apuesta": {
                texto: "A \"friend\" offers you money to \"go easy\" in a match.",
                opt0: { label: "🚪 I kick him out immediately", out0: "Total integrity. (+morale)", out1: "You did the right thing, though it left you uneasy. (+morale)" },
                opt1: { label: "🤫 I tell him I'll think about it", out0: "You left yourself exposed to a mess. (−morale)", out1: "You cut it off before it went further." },
                opt2: { label: "🚨 I report it to the club", out0: "You played clean and covered yourself. (+morale)", out1: "The guy started threatening you. (−morale)" },
            },
            "cabala": {
                texto: "You're on an unbeaten streak and the superstition is not washing your lucky socks.",
                opt0: { label: "🤢 I keep wearing them", out0: "The streak continues. (+morale)", out1: "It ended anyway and you smell horrible. (−morale)" },
                opt1: { label: "🌬️ I air them out but don't wash them", out0: "Committed to the ritual. (+slight morale)", out1: "No real effect either way." },
                opt2: { label: "🧼 I wash them, I'm an adult", out0: "Hygiene above all. (+slight morale)", out1: "You lost right after and everyone blamed you. (−morale)" },
            },
            "utilero": {
                texto: "The kit man is going through a tough personal time.",
                opt0: { label: "🤗 I lend him a big hand", out0: "People at the club love you more every day. (+morale)", out1: "Noble gesture, though a bit awkward. (+morale)" },
                opt1: { label: "👂 I listen for a while", out0: "It did him good to vent. (+morale)", out1: "You talked and each went on with your day." },
                opt2: { label: "😶 Not my business", out0: "Cold, people at the club noticed. (−morale)", out1: "Someone else stepped in." },
            },
            "influencer": {
                texto: "An influencer offers you followers for a ridiculous challenge.",
                opt0: { label: "📲 I do it, who cares", out0: "It went viral, you had fun with it. (+morale)", out1: "It was cringe and you got mocked. (−morale)" },
                opt1: { label: "🎬 I do it my own way", out0: "You put your own spin on it and it landed. (+morale)", out1: "It went by unnoticed." },
                opt2: { label: "🙅 No way", out0: "Dignity intact. (+slight morale)", out1: "The one who did it gained a million followers. (−morale)" },
            },
            "pelota_hattrick": {
                texto: "In the last match you scored a hat-trick and kept the ball.",
                opt0: { label: "🖊️ I sign it and hang it at home", out0: "An eternal memory. (+morale)", out1: "It gathers dust on a shelf." },
                opt1: { label: "🎁 I auction it for charity", out0: "You raised a ton for the kids. (+morale)", out1: "Nobody bid much, a bit embarrassing. (−morale)" },
                opt2: { label: "⚽ I use it for training", out0: "A ball with history, you put in the hours. (+slight morale)", out1: "It went flat within a week. Meh." },
            },
            "capitan_fecha": {
                texto: "The coach offers you the captain's armband for one matchday.",
                opt0: { label: "💪 I take it and give it my all", out0: "Total leadership, they respect you. (+morale)", out1: "You tried to rally the team and nobody listened. (−morale)" },
                opt1: { label: "🤝 I accept without overdoing it", out0: "You led by example. (+morale)", out1: "Quiet matchday, you did your job." },
                opt2: { label: "😰 I can't handle it, I pass", out0: "You showed insecurity. (−morale)", out1: "The coach understood it wasn't your moment." },
            },
            "barra": {
                texto: "A group of ultras invites you to \"a meeting\" at their headquarters.",
                opt0: { label: "🤝 I go and make friends", out0: "Bad company, you got tangled in a mess. (−morale)", out1: "You realized in time and backed out. (−morale)" },
                opt1: { label: "📵 I don't answer", out0: "Better to stay away from that.", out1: "They got offended and now have it out for you. (−morale)" },
                opt2: { label: "🛡️ I report it to the club", out0: "You played it clean, management backed you. (+morale)", out1: "The ultras found out and marked you. (−morale)" },
            },
            "documental": {
                texto: "A production company wants to make a documentary about your life.",
                opt0: { label: "🎥 I accept and show EVERYTHING", out0: "It came out epic and human. (+morale)", out1: "You showed too much and felt exposed. (−morale)" },
                opt1: { label: "🎯 Just the football side", out0: "Neat and professional. (+morale)", out1: "It came out boring and nobody watched it. (−morale)" },
                opt2: { label: "⏳ I'll leave it for when I retire", out0: "Mature decision.", out1: "The production company went with someone else." },
            },
            "penales_quiero": {
                texto: "The coach is deciding who will be the team's penalty taker.",
                opt0: { label: "🙋 I volunteer", out0: "You earned the role and the trust. (+morale)", out1: "In practice you missed 3 in a row and got ruled out. (−morale)" },
                opt1: { label: "🎯 I say I'll practice and see", out0: "You showed commitment. (+morale)", out1: "You ended up second on the list. Normal." },
                opt2: { label: "🤐 Let someone else take them", out0: "You didn't take on the pressure.", out1: "The chosen one keeps missing, you think \"I would've scored those\". (−morale)" },
            },
            "pibe_inferiores": {
                texto: "A youth academy kid asks you for advice before his debut.",
                opt0: { label: "🧠 I sit down and talk at length", out0: "You became his role model. (+morale)", out1: "You helped him out, though he didn't understand much. (+morale)" },
                opt1: { label: "💬 I give him a couple of tips", out0: "Short but useful advice. (+morale)", out1: "He barely listened. It passed." },
                opt2: { label: "😒 \"I don't have time, kid\"", out0: "You treated him badly, bad karma. (−morale)", out1: "You were in a rush, he understood." },
            },
            "seleccion_amistoso": {
                texto: "You get called up to the {pais} national team for a mid-season friendly.",
                opt0: { label: "🙌 I go all in, it's an honor", out0: "Wearing the {pais} shirt filled you with energy. (+morale)", out1: "You came back exhausted from the trip and played poorly. (−morale)" },
                opt1: { label: "🤝 I go but ask to be careful", out0: "You added minutes without burning out. (+morale)", out1: "You barely played. Routine." },
                opt2: { label: "🚫 I withdraw, I'd rather rest", out0: "The {pais} press crucified you. (−morale)", out1: "You rested and came back like new. (+morale)" },
            },
            "resaca": {
                texto: "You wake up hungover and there's a double training session.",
                opt0: { label: "🤮 I go as best I can", out0: "You threw up at the training ground. Historic embarrassment. (−morale)", out1: "You barely got through it. (−morale)" },
                opt1: { label: "☕ Gallons of coffee and grind through it", out0: "You scraped by. Nobody noticed.", out1: "You still played terribly. (−morale)" },
                opt2: { label: "🤧 I say I'm \"coming down with something\"", out0: "You got away with it, but felt guilty.", out1: "The doctor checked you and figured it all out. (−morale)" },
            },
            "mansion": {
                texto: "You buy a mansion and want a housewarming party.",
                opt0: { label: "🎊 Big party with 200 guests", out0: "Legendary and no fallout. (+morale)", out1: "It got out of hand and made the news. (−morale)" },
                opt1: { label: "🤝 Barbecue with teammates", out0: "You brought the group together in your new house. (+morale)", out1: "The barbecue burned at the new house. Bad omen." },
                opt2: { label: "🍽️ Small dinner with family", out0: "Calm and warm. (+slight morale)", out1: "The housewarming lacked spark." },
            },
            "insulto_calle": {
                texto: "A rival fan curses at you at the supermarket in front of everyone.",
                opt0: { label: "🤬 I shout back", out0: "It almost came to blows, you got filmed. (−morale)", out1: "You put him in his place and people applauded. (+morale)" },
                opt1: { label: "😏 I sign an autograph for him", out0: "You disarmed him with class. (+morale)", out1: "He threw it back at your head. (−morale)" },
                opt2: { label: "🛒 I keep shopping", out0: "You didn't even look at him. Coldness. (+slight morale)", out1: "He followed you to the register. Awkward." },
            },
            "renovacion_charla": {
                texto: "The club offers to renew your contract for less money than you expected.",
                opt0: { label: "😤 I demand double or I leave", out0: "The relationship with management soured. (−morale)", out1: "They gave it to you. You got your way! (+morale)" },
                opt1: { label: "🤝 I negotiate a middle ground", out0: "A fair deal for both sides. (+morale)", out1: "The talk stayed open. It passed." },
                opt2: { label: "❤️ I sign, I love this shirt", out0: "The fans idolize you. (+morale)", out1: "You later found out someone worse got paid more. (−morale)" },
            },
            "festejo_lesion": {
                texto: "You're rehearsing an acrobatic celebration for your next goal.",
                opt0: { label: "🤾 The full triple somersault", out0: "It looks great, you're going to nail it. (+morale)", out1: "You got injured REHEARSING. Unbelievable. (−morale)" },
                opt1: { label: "🕺 A simple little dance", out0: "Catchy and no risk. (+morale)", out1: "A bit cheesy, but it's fine." },
                opt2: { label: "🤫 I dedicate it to my family", out0: "An emotional gesture prepared with love. (+morale)", out1: "You decided to improvise on the day of the goal." },
            },
            "sesion_fotos": {
                texto: "Photo shoot for the club's new jersey.",
                opt0: { label: "😎 Ridiculous poses on purpose", out0: "The club didn't find it funny. (−morale)", out1: "It became a meme and people loved you for it. (+morale)" },
                opt1: { label: "🤩 I bring energy and charisma", out0: "The photos went viral online. (+morale)", out1: "You came out with your eyes closed in every shot. (−morale)" },
                opt2: { label: "📸 Serious player face", out0: "Correct and professional.", out1: "Standard photos." },
            },
            "jingle": {
                texto: "They ask you to record a jingle for the club's ad.",
                opt0: { label: "🎶 I sing even though I'm off-key", out0: "It sounded awful and you got mocked. (−morale)", out1: "So bad it became an ironic hit. (+morale)" },
                opt1: { label: "🎸 I bring some flow", out0: "It became a club hit. (+morale)", out1: "Nobody remembers it. (−slight morale)" },
                opt2: { label: "🗣️ I talk, I don't sing", out0: "You got through it decently.", out1: "It came out flat. It passed." },
            },
            "bandera": {
                texto: "The fans are preparing a giant banner with your face on it.",
                opt0: { label: "😭 I get emotional and hug it", out0: "An image for the club's history books. (+morale)", out1: "You tripped and almost ripped it. Scary moment." },
                opt1: { label: "🙌 I wave to it from a distance", out0: "Warm, simple gesture. (+morale)", out1: "They didn't see you well. Meh." },
                opt2: { label: "😬 I say it makes me uncomfortable", out0: "The fans got offended. (−morale)", out1: "They understood, you're shy." },
            },
            "esquema_dt": {
                texto: "You disagree with the coach's tactical setup.",
                opt0: { label: "🗯️ I argue about it in front of everyone", out0: "You embarrassed him, you got benched. (−morale)", out1: "You were right and the team improved. (+morale)" },
                opt1: { label: "🚪 I talk to him privately", out0: "A mature talk, he took you more into account. (+morale)", out1: "He told you to be quiet. (−morale)" },
                opt2: { label: "🤐 I keep it to myself", out0: "You bit your tongue. Same as always.", out1: "The frustration worked against you. (−morale)" },
            },
            "mascota": {
                texto: "A stray dog sticks around the training ground with the squad.",
                opt0: { label: "🦴 I adopt it as the team's mascot", out0: "It's the new lucky charm, everyone's happy. (+morale)", out1: "It bit you of all people. (−morale)" },
                opt1: { label: "🍖 I feed it and see", out0: "Nice gesture, the squad approved. (+morale)", out1: "It left the next day. It passed." },
                opt2: { label: "🚷 Get it out of here", out0: "You came off as the bad guy. (−morale)", out1: "You have allergies, they understood." },
            },
            "fifa_noche": {
                texto: "A FIFA gaming marathon with teammates until whatever hour.",
                opt0: { label: "🌙 Until 5 AM non-stop", out0: "You showed up dead at training. (−morale)", out1: "You won the tournament and locker room glory. (+morale)" },
                opt1: { label: "🎮 A couple of matches and then bed", out0: "You had fun without overdoing it. (+morale)", out1: "You lost quickly and left. Meh." },
                opt2: { label: "😴 I rest tonight", out0: "As professional as they come. (+morale)", out1: "You missed an epic night." },
            },
            "cerveza_marca": {
                texto: "A beer brand offers you to be their face during preseason.",
                opt0: { label: "🍻 I sign and go to the events", out0: "You handled it well without neglecting your fitness. (+morale)", out1: "So many events left you sluggish. (−morale)" },
                opt1: { label: "📝 I sign but skip the events", out0: "Good money, zero hassle. (+morale)", out1: "Just the ad. Normal." },
                opt2: { label: "🚫 No, I'm in preseason", out0: "Total focus. (+morale)", out1: "You lost a big contract, your agent is furious. (−morale)" },
            },
            "camiseta_partido": {
                texto: "A kid messages you on social media asking for a signed jersey.",
                opt0: { label: "👕 I send it with a dedication", out0: "Story of the year, the kid was in tears. (+morale)", out1: "Nice gesture, though the mail lost it for a month. (+morale)" },
                opt1: { label: "📸 I send a signed photo", out0: "Simple gesture but he appreciated it. (+slight morale)", out1: "He wanted the jersey, he was a bit hurt." },
                opt2: { label: "😶 I don't have time for that", out0: "The message went viral, it didn't look good. (−morale)", out1: "You were swamped, you didn't even see it." },
            },
            "avion_demora": {
                texto: "The flight is delayed 6 hours and everyone's in a bad mood.",
                opt0: { label: "🃏 I suggest a card game", out0: "You brought the group together during the wait. (+morale)", out1: "Nobody wanted to play, you were left alone. (−morale)" },
                opt1: { label: "🎧 I put on my headphones", out0: "You made it through in your own world.", out1: "The wait passed, you didn't even notice." },
                opt2: { label: "😡 I complain loudly", out0: "You spread the bad mood. (−morale)", out1: "Your complaint worked and they changed our flight. (+morale)" },
            },
            "ingles": {
                texto: "You're offered an English course, thinking about your international career prospects.",
                opt0: { label: "🎯 I go all in", out0: "Head set on growing. (+morale)", out1: "You understood nothing and got frustrated. (−morale)" },
                opt1: { label: "📖 I go occasionally", out0: "Something's better than nothing.", out1: "Slow but steady progress." },
                opt2: { label: "😴 Too much effort, I quit", out0: "Zero drive to improve. (−morale)", out1: "You can always get by with gestures. Meh." },
            },
            "penal_superclasico": {
                texto: "The big derby is coming up. The coach asks who's willing to take a penalty if one comes up.",
                opt0: { label: "🎯 I volunteer, I can handle it", out0: "The coach picked you, you feel unstoppable. (+morale)", out1: "You volunteered but he picked someone else. Exposed. (−morale)" },
                opt1: { label: "🤔 If nobody wants it, I'll take it", out0: "You showed character without forcing it. (+morale)", out1: "Someone else volunteered first. It passed." },
                opt2: { label: "🙈 Let the experienced ones take it", out0: "You showed the pressure gets to you. (−morale)", out1: "Sensible call, the coach appreciated it. (+morale)" },
            },
            "comentarista": {
                texto: "You get invited to be a commentator for a day.",
                opt0: { label: "🗣️ I criticize everyone", out0: "You made enemies in both locker rooms. (−morale)", out1: "Sharp and spicy, people loved you. (+morale)" },
                opt1: { label: "😄 I bring humor", out0: "They asked you to be a regular commentator. (+morale)", out1: "You froze up and went speechless live. (−morale)" },
                opt2: { label: "🎙️ I comment neutrally", out0: "Correct, no controversy.", out1: "Boring but tidy." },
            },
            "tatuador_amuleto": {
                texto: "A fortune teller offers you an amulet \"to never miss a goal again\".",
                opt0: { label: "💸 I pay a fortune for it", out0: "He was a fraud, he took your money. (−morale)", out1: "Coincidence or not, you scored 3 straight goals. (+morale)" },
                opt1: { label: "🪙 I give him a coin just in case", out0: "Just in case, you lose nothing. (+slight morale)", out1: "The amulet did nothing. Obviously." },
                opt2: { label: "😂 I burst out laughing in his face", out0: "The situation amused you. (+morale)", out1: "He cursed you and the following week you missed an easy one. (−morale)" },
            },
            "balon_oro_gala": {
                texto: "You're invited to the Ballon d'Or gala, even though you know you won't win this year.",
                opt0: { label: "🎩 I go with full enthusiasm", out0: "You enjoyed the night among the world's best. (+morale)", out1: "You got bored waiting 3 hours for nothing. (−morale)" },
                opt1: { label: "📱 I go, take some photos and leave early", out0: "You fulfilled the commitment without wearing yourself out. (+morale)", out1: "Nobody noticed you left early." },
                opt2: { label: "🙅 I'd rather not go", out0: "You rested peacefully at home.", out1: "Your agent got angry about the no-show. (−morale)" },
            },
            "polemica_redes": {
                texto: "You post a spicy opinion about the league's level and it blows up on social media.",
                opt0: { label: "🔥 I stand by what I said", out0: "You owned your words, they respected you. (+morale)", out1: "It turned into a huge media scandal. (−morale)" },
                opt1: { label: "😅 I clarify it was a joke", out0: "You defused the tension with humor. (+slight morale)", out1: "Nobody believed you. (−morale)" },
                opt2: { label: "🗑️ I delete the post", out0: "It was quickly forgotten.", out1: "They'd already taken a screenshot. Embarrassing. (−morale)" },
            },
            "nostalgia_lejos": {
                texto: "You've been away from home for months and homesickness is hitting hard.",
                opt0: { label: "📞 A long video call with the family", out0: "It fully recharged your batteries. (+morale)", out1: "The connection kept cutting out." },
                opt1: { label: "✈️ I take a few days off and fly to see them", out0: "You came back refreshed and clear-headed. (+morale)", out1: "The quick trip left you more tired. (−morale)" },
                opt2: { label: "💪 I tough it out and stay focused", out0: "Professional to the end. (+slight morale)", out1: "The loneliness started to really weigh on you. (−morale)" },
            },
            "nutricionista_estricto": {
                texto: "The club's nutritionist proposes a very strict diet plan.",
                opt0: { label: "🥗 I follow it to the letter", out0: "You feel much lighter on the pitch. (+morale)", out1: "You miss your usual food. (−morale)" },
                opt1: { label: "🍝 I adapt it my own way", out0: "You found a balance that works for you. (+morale)", out1: "No real change either way." },
                opt2: { label: "🍕 I keep eating as usual", out0: "At least you're comfortable.", out1: "The coaching staff called you out. (−morale)" },
            },
            "amistad_rival": {
                texto: "You've become close friends with a star from a rival team and the press criticizes it.",
                opt0: { label: "📸 We post about it anyway", out0: "People valued the good sportsmanship. (+morale)", out1: "Part of the fanbase strongly resented it. (−morale)" },
                opt1: { label: "🤫 We keep it private", out0: "You protected the friendship without noise. (+morale)", out1: "A photo leaked anyway." },
                opt2: { label: "🚪 I distance myself from that friendship", out0: "Less media drama.", out1: "It hurt to distance yourself from someone you care about. (−morale)" },
            },
            "catastrofe_solidaria": {
                texto: "A natural disaster hit a region hard and the club organizes a relief effort.",
                opt0: { label: "❤️ I donate a large part of my salary", out0: "Your gesture went viral for the right reasons. (+morale)", out1: "You really helped, even if almost nobody found out. (+morale)" },
                opt1: { label: "🤝 I take part in the charity match/event", out0: "You added presence and visibility to the cause. (+morale)", out1: "You did the bare minimum." },
                opt2: { label: "🤷 I'd rather not get involved", out0: "Your absence was noticed and it looked bad. (−morale)", out1: "Nobody mentioned it afterward." },
            },
        },
};

export default resources;
